const IconPayment = (props: {
  refPayment: string | undefined;
  size?: string;
}) => {
  const { refPayment, size } = props;
  return refPayment ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={size ? size : "50"}
      height={size ? size : "50"}
      x="0"
      y="0"
      viewBox="0 0 512 512"
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <circle
            cx="256"
            cy="256"
            fill="#ffe14d"
            r="256"
            data-original="#ffe14d"
          ></circle>
          <path
            d="m512 256c0-141.159-114.841-256-256-256v512c141.159 0 256-114.841 256-256z"
            fill="#ffbb33"
            data-original="#ffbb33"
          ></path>
          <g>
            <g>
              <path
                d="m256 451c-107.52 0-195-87.48-195-195s87.48-195 195-195 195 87.48 195 195-87.48 195-195 195z"
                fill="#ffbb33"
                data-original="#ffbb33"
              ></path>
            </g>
          </g>
          <path
            d="m451 256c0-107.52-87.48-195-195-195v390c107.52 0 195-87.48 195-195z"
            fill="#e68a2e"
            data-original="#e68a2e"
          ></path>
          <g id="Cent_2_">
            <path
              d="m271 242.068v-59.306c17.252 4.233 30 15.333 30 28.092 0 8.291 6.709 15 15 15s15-6.709 15-15c0-28.982-25.801-53.214-60-58.786v-16.214c0-8.291-6.709-15-15-15s-15 6.709-15 15v16.214c-34.199 5.572-60 29.804-60 58.786s25.801 53.214 60 58.786v59.306c-17.252-4.233-30-15.333-30-28.092 0-8.291-6.709-15-15-15s-15 6.709-15 15c0 28.982 25.801 53.214 60 58.786v16.36c0 8.291 6.709 15 15 15s15-6.709 15-15v-16.36c34.199-5.572 60-29.804 60-58.786s-25.801-53.215-60-58.786zm-60-31.214c0-12.759 12.748-23.859 30-28.092v56.184c-17.252-4.234-30-15.334-30-28.092zm60 118.092v-56.184c17.252 4.233 30 15.333 30 28.092s-12.748 23.858-30 28.092z"
              fill="#ffe14d"
              data-original="#ffe14d"
            ></path>
          </g>
          <path
            d="m271 376v-16.36c34.199-5.572 60-29.804 60-58.786s-25.801-53.214-60-58.786v-59.306c17.252 4.233 30 15.333 30 28.092 0 8.291 6.709 15 15 15s15-6.709 15-15c0-28.982-25.801-53.214-60-58.786v-16.214c0-8.291-6.709-15-15-15v270.146c8.291 0 15-6.709 15-15zm0-103.239c17.252 4.233 30 15.333 30 28.092s-12.748 23.859-30 28.092z"
            fill="#ffbb33"
            data-original="#ffbb33"
          ></path>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={size ? size : "50"}
      height={size ? size : "50"}
      x="0"
      y="0"
      viewBox="0 0 512 512"
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <path
            d="m256 512c-68.38 0-132.668-26.628-181.02-74.98s-74.98-112.64-74.98-181.02 26.629-132.667 74.98-181.02 112.64-74.98 181.02-74.98 132.668 26.628 181.02 74.98 74.98 112.64 74.98 181.02-26.629 132.667-74.98 181.02-112.64 74.98-181.02 74.98zm0-480c-123.514 0-224 100.486-224 224s100.486 224 224 224 224-100.486 224-224-100.486-224-224-224z"
            fill="#000000"
            data-original="#000000"
          ></path>
          <path
            d="m256 240c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40c0 8.836 7.163 16 16 16s16-7.164 16-16c0-34.201-23.978-62.888-56-70.186v-17.814c0-8.836-7.163-16-16-16s-16 7.164-16 16v17.814c-32.022 7.298-56 35.985-56 70.186 0 39.701 32.299 72 72 72 22.056 0 40 17.944 40 40s-17.944 40-40 40-40-17.944-40-40c0-8.836-7.163-16-16-16s-16 7.164-16 16c0 34.201 23.978 62.888 56 70.186v17.814c0 8.836 7.163 16 16 16s16-7.164 16-16v-17.814c32.022-7.298 56-35.985 56-70.186 0-39.701-32.299-72-72-72z"
            fill="#000000"
            data-original="#000000"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default IconPayment;
